<template>
  <svg
    id="components-svg-logo"
    width="100px"
    height="16px"
    viewBox="0 0 100 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :class="color"
  >
    <polygon points="12.8346918 0 8.58421525 7.91351149 4.33894257 0 0 0 8.58421525 16 17.1717172 0" />
    <polygon
      points="29.7996234 0 21.2121212 16 25.5507987 16 29.7996234 8.0862389 34.0470785 16 38.3838384 16 29.7998974 0"
    />
    <polygon
      points="72.2185244 0 63.6363636 16 67.9737349 16 72.2185244 8.0862389 76.4685183 16 80.8080808 16 72.2187983 0"
    />
    <polygon points="86.8686869 0 86.8686869 16 91.1197352 16 91.1197352 4.64645953 100 16 100 0" />
    <path
      d="M46.605634,7.99764542 C46.605634,5.69833475 48.6436368,3.83524127 51.1474997,3.83524127 L58.5858586,3.83524127 C57.0504659,1.53419565 54.3028641,0 51.1474997,0 C46.3289282,0 42.4242424,3.57945938 42.4242424,7.99764542 C42.4242424,12.4173186 46.3289282,16 51.1474997,16 C54.3028641,16 57.0504659,14.4605995 58.5858586,12.1652544 L51.1474997,12.1652544 C48.6436368,12.1652544 46.605634,10.3001781 46.605634,7.99764542"
    />
  </svg>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "components-svg-logo",
  props: {
    color: {
      type: String,
      validator: (value: string) => ["white", "gray-2", "gray-5", "violet-1"].indexOf(value) !== -1,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import "~@vacancorp/vacan-scss/variables/colors.scss";
svg#components-svg-logo {
  &.white {
    fill: $white;
  }
  &.gray-2 {
    fill: $knight;
  }
  &.gray-5 {
    fill: $text;
  }
  &.violet-1 {
    fill: $vacan;
  }
}
</style>
